module.exports = __webpack_public_path__ + "img/uploadIcon.87b257ea.svg";